export default function Modal({ onClose, title, children, wide }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur p-4" onClick={onClose}>
      <div className={"bg-[#14101c] border border-white/10 rounded-2xl w-full " + (wide ? "max-w-2xl" : "max-w-lg") + " max-h-[92vh] overflow-y-auto"} onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#14101c] border-b border-white/10 px-5 py-3 flex items-center justify-between">
          <h3 className="font-bold text-white text-sm">{title}</h3>
          <button onClick={onClose} className="text-slate-500 hover:text-white text-xl leading-none" data-testid="modal-close">×</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
